import { Inject, Injectable, Provider } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateLoader } from '@ngx-translate/core';
import { AppConfig } from '@shared/interfaces';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable()
class StoreTranslationsLoader implements TranslateLoader {
  constructor(private store: Store<{ config: AppConfig }>) {}

  getTranslation(lang: string): Observable<any> {
    return this.store.select('config').pipe(
      first(),
      map((e) => e.translations[lang || e.defaultLanguage])
    );
  }
}

export const translatesLoader: Provider = {
  provide: TranslateLoader,
  useClass: StoreTranslationsLoader,
  deps: [[new Inject(Store)]],
};
